import * as config from './config'
import axios from 'axios'

import {
  ElMessage
} from 'element-plus'
// import router from '../../router/index';
// 使用vue3的axios创建方式 baseURL的配置会被vueconfgjs 覆盖，以vue config js 里的配置为主
let axioses = axios.create({
    timeout: 16000,
    withCredentials: false,
})
axioses.defaults.baseURL = config.default.baseURL
axioses.interceptors.request.use(
  config => {
    if (sessionStorage.getItem('token')) {
      config.headers['token'] = sessionStorage.getItem('token');
    }
    return config // 对config处理完后返回，下一步将向后端发送请求
  },
  error => { // 当发生错误时，执行该部分代码
    console.log(error); //调试用
    return Promise.reject(error)
  }
)
// 响应的代码拦截
axioses.interceptors.response.use(
  response => { // 该处为后端返回整个内容
    console.log(response, 666);
    const {
      code,
      msg,
      data
    } = response.data // 结构数据
    // 判断是否为成功执行
    if (code == 0) {
      // return Promise.resolve(data)
      return data
      // return response.data
    } else if (code == -1) {
      ElMessage .warning(msg) // 提示错误信息
      return Promise.reject(new Error(msg))
    } else {
      // 业务已经错误了 还能进then ? 不能 ！ 应该进catch
      ElMessage .warning(msg) // 提示错误信息
      return Promise.reject(new Error(msg))

    }
  },
  error => { // 当发生错误时，执行该部分代码
    console.log(error); //调试用
    return Promise.reject(error)
  }
)
export default axioses;
